// extracted by css-extract-rspack-plugin
export default {"detailsBox":"C8ScedfaSUEPD9R2","content":"fj_Ukanp8sJOJptf"};